<!-- 学员管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>手机号码：</span>
          <el-input
            class="w300"
            v-model="queryInfo.mobile"
            clearable
            size="small"
            placeholder="请输入学员手机号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>呼叫类型：</span>
          <el-select v-model="queryInfo.type" size="small" class="w150Select">
            <el-option label="请选择号码类型" value="-1"></el-option>
            <el-option label="平台导入" :value="1"></el-option>
            <el-option label="自有号码" :value="2"></el-option>
          </el-select>
        </div>
        <!-- <div class="searchItem">
        <span>呼叫记录ID：</span>
        <el-input class="w300" v-model="queryInfo.call_id" clearable size="small" placeholder=请输入记录ID></el-input>
      </div> -->
        <div class="searchItem" v-if="role == 'admin'">
          <span>呼叫人：</span>
          <el-input
            class="w300"
            v-model="queryInfo.realname"
            clearable
            size="small"
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>标签</span>
          <!-- <el-input class="w180" v-model="queryInfo.goods" clearable size="small"></el-input> -->
          <el-select
            v-model="selectTags"
            filterable
            remote
            multiple
            reserve-keyword
            placeholder="请输入关键词"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item, index) in options1"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>呼叫时间：</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>扣费时间：</span>
          <el-date-picker
            v-model="costTimeArr"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectPayData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <div class="searchItem">
          <span>计费：</span>
          <el-select
            v-model="queryInfo.price_status"
            size="small"
            class="w200Select"
          >
            <el-option
              v-for="item in chargingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <!-- <el-button type="primary" size="small" @click="queryTable"
        >搜索</el-button
      >
      <el-button type="warning" size="small" @click="resetQuery"
        >重置</el-button
      > -->
 
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
      </div>
      <div class="addInfo">
        <el-button type="text" @click="resetCodeShow = true"
          >计费说明<i class="el-icon-question el-icon--right"></i
        ></el-button>


        
        <MyButton
          value="导出"
          size="medium"
          type="1"
          @click="downloadExcel"
        ></MyButton>
      </div>
      <div class="table">
        <TableComponents :columns="columns" :tableData="tableList">
          <!--号码类型-->
          <template slot="type" slot-scope="{ row }">
            {{ row.type == 1 ? "合作平台" : "自有平台" }}
          </template>
          <!-- 学员标签管理 -->
          <template slot="studentLabel" slot-scope="{ row }">
            <el-popover
              placement="right"
              trigger="hover"
              v-if="row.tags.length > 3"
            >
              <div style="width: 200px">
                <el-tag
                  v-for="(item, index) in row.tags"
                  :key="index"
                  style="margin: 5px"
                  >{{ item }}</el-tag
                >
              </div>
              <div slot="reference">
                <el-tag
                  v-for="(item, index) in row.tags"
                  :key="index"
                  style="margin: 5px"
                  v-show="index < 3"
                  >{{ item }}</el-tag
                >
                ...
              </div>
            </el-popover>
            <div v-else>
              <el-tag
                v-for="(item, index) in row.tags"
                :key="index"
                style="margin: 5px"
                >{{ item }}</el-tag
              >
            </div>
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 计费说明弹窗 -->
    <el-dialog
      title="计费说明"
      :visible.sync="resetCodeShow"
      class="formDialog"
      width="500px"
    >
      <div v-html="notice"></div>
    </el-dialog>
  </div>
</template>

<script>
import studentApi from "@/api/student.js";
import callPhoneApi from "@/api/callphone";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import qee from "qf-export-excel";
import commonApi from "@/api/common";
import MyButton from "@/components/MyButton.vue";
// 外呼扣费记录
export default {
  name: "money",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    var confirmPasswordVerify = (_, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      } else if (value != this.codeInfo.new_password) {
        return callback(new Error("两次密码输入需一致"));
      } else {
        callback();
      }
    };
    return {
      options: [],
      options1: [],
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        mobile: "", //状态 -1全部 1启用 0禁用
        type: "-1", //是否激活 -1全部 1启用 0禁用
        call_id: "", //用户信息 支持账号真实姓名手机号
        realname: "",
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
        tag_id: "", //标签id
        pay_start_time: "", //
        pay_end_time: "",
        price_status:'0'
      },
      columns: [
        //列数据
        // {label:"呼叫记录ID",prop:"_id"},
        { label: "被叫号码", prop: "mobile" },
        { label: "标签", prop: "tags", width: 200 },
        { label: "呼叫类型", prop: "type", isMyself: true },
        { label: "呼叫人", prop: "realname" },
        { label: "呼叫时间", prop: "start_at" },
        { label: "时长", prop: "time", width: 130 },
        { label: "计费", prop: "price" },
        { label: "扣费时间", prop: "finish_at" },
      ],
      tableList: [],
      // 新增编辑表单数据
      addFormShow: false,
      userInfo: {
        mobile: "",
        realname: "",
        id_card: "",
        remark: "",
        status: 1,
        uid: "",
      },
      rules: {
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入2-6个汉字"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },

      // 重置密码弹窗
      resetCodeShow: false,
      codeInfo: {
        new_password: "",
        new_password_confirmation: "",
      },
      codeRules: {
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "密码必须使用6-15位字符",
            trigger: "change",
          },
        ],
        new_password_confirmation: [
          { required: true, validator: confirmPasswordVerify, trigger: "blur" },
        ],
      },

      editLabelShow: false,
      // 已添加标签
      userLabel: [],
      userAddLabel: [],
      userDeleteLabel: [],
      // 可添加标签
      addLabel: [],
      addNewLabel: "",
      chioceUid: "",

      // 学员开课字段
      selectBuyGoodsShow: false,

      // 读取文件
      fileData: "",

      // good
      goodsNeedId: "",
      outerVisible: false,
      fileName: "",
      excelList: [],
      timeFrame: [],
      costTimeArr: [],
      selectTags: [],
      notice: "",
      role: "",
      chargingOptions: [
      // 0全部 1有计费 2无计费
        { label: "全部", value: '0'},
        { label: "有计费", value: '1' },
        { label: "无计费", value: '2' },
      ],
      downExcelLoading: false, // 下载excel时，按钮的加载状态
      excelTabelList:[],
      typeOptions:[ 
        { label: "平台导入", value: 1},
        { label: "自有号码", value: 2},
      ]
    };
  },
  computed: {
    typeMap() {
      return new Map(
        this.typeOptions.map((item) => [item.value, item.label])
      );
    },
    dialogType() {
      //  'this.userInfo.id',this.userInfo.uid);
      return this.userInfo.uid ? "编辑" : "新增";
    },
    isSalespersonr() {
      //  this.$store.state.user.userInfo.role,this.$store.state.user.userInfo.role == 'salespersonr');
      return this.$store.state.user.userInfo.role == "salespersonr";
    },
  },
  watch: {
    selectBuyGoodsShow: {
      handler(_newVal) {
        //  _newVal);
      },
    },
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          Object.keys(this.userInfo).forEach((key) => {
            if (typeof this.userInfo[key] == "string") {
              this.userInfo[key] = "";
            } else if (typeof this.userInfo[key] == "number") {
              this.userInfo[key] = 1;
            }
          });
          this.userInfo.uid = "";
        }
      },
    },
    resetCodeShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.codeInfo);
          this.$refs["codeInfoForm"].resetFields();
        }
      },
    },
    editLabelShow: {
      handler(_newVal) {
        if (!_newVal) {
          this.addNewLabel = "";
        }
      },
    },
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },
  },
  created() {
    this.getMe();
    this.getDic();
    // this.getAllTags();
    this.getTobSearchTags();
    this.queryTable();
  },
  methods: { 
    async downloadExcel() {
      // 导出
      this.downExcelLoading = true;
      var titleList = [
        { title: "被叫号码", key: "mobile" },
        { title: "标签", key: "tagsArr" },
        { title: "呼叫类型", key: "typeName" },
        { title: "呼叫人", key: "realname" },
        { title: "呼叫时间", key: "start_at" },
        { title: "时长", key: "time" },
        { title: "计费", key: "price" },
        { title: "扣费时间", key: "finish_at" }, 
      ];
      let query = deepClone(this.queryInfo);
      query.limit = 100000;
      const res = await callPhoneApi.callOrders(query);
      if (res.code == 200) {
        // this.excelVisible = true;
        res.data.data.forEach((item) => {
          item.typeName = this.typeMap.get(item.type)
        });
        res.data.data.forEach((item) => {
          var tagsArr = []
          if(item.tags&&item.tags.length>0) { 
            tagsArr = []
            item.tags.forEach((itemB) => {
              tagsArr.push(itemB)
            }) 
            item.tagsArr = tagsArr.toString()
          }
        });
        console.log("excelTabelList", res.data.data)
        this.excelTabelList = res.data.data; 
        const randomStr = this.getCurrentDate() + this.generate();
        const fileName = randomStr;
        qee(titleList, this.excelTabelList, fileName);
      } else {
        this.$message.error(res.message);
      }

      // this.$confirm("是否确认导出开卡数据?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     let query = deepClone(this.queryInfo);
      //     query.limit = 100000;
      //     commonApi.getTobStudyCard(query).then((res) => {
      //       if (res.code === 200) {
      //         this.excelVisible = true;
      //       } else {
      //         this.$message.error(res.message);
      //       }
      //     });
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消",
      //     });
      //   });
    },
    getCurrentDate() {
      let now = new Date();
      let year = ("000" + now.getFullYear()).slice(-4);
      let month = ("0" + (now.getMonth() + 1)).slice(-2);
      let day = ("0" + now.getDate()).slice(-2);
      return year.toString() + month.toString() + day.toString();
    },
    // 生成随机数
    generate() {
      let timeStr = new Date().valueOf() + "";
      let randomStr = Math.random() + "";
      return timeStr.slice(2, 8) + randomStr.slice(2, 8);
    },
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.role = res.data.role;
        // console.log("getMe", res.data.role);
      }
    },

    getDic() {
      commonApi.getInfoToName({ name: "outwardcal" }).then((res) => {
        console.log("1----", res.data);
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "billinginstructions") {
              this.notice = item.value;
            }
          });
        }
      });
    },
    async getTobSearchTags() {
      const res = await commonApi.getTobSearchTags({ common_tag_type: 1 });
      this.options1 = res.data.data;
    },
    // async getAllTags() {
    //   const res = await studentApi.tobTagsList({ page: 1, limit: 10000 });
    //   this.options1 = res.data.data;
    // },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobGoodList({ good_name: companyName });
          this.options = res.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobTagsList({ name: companyName });
          this.options1 = res.data.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 列表数据
    async queryTable(_type) {
      let params = deepClone(this.queryInfo);
      if (this.selectTags.length > 0) {
        params.tag_id = this.selectTags.join(",");
      } else {
        params.tag_id = "";
      }

      const res = await callPhoneApi.callOrders(params);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data; 
        //  this.tableList);
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    viewDetail(row) {
      if (row.uid) {
        Object.assign(this.userInfo, row);
      }
      //  this.userInfo);
      this.addFormShow = true;
    },
    // 添加｜｜修改数据
    addUser(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res;
          if (this.userInfo.uid) {
            res = await studentApi.studentsEdit(this.userInfo);
          } else {
            res = await studentApi.studentsAdd(this.userInfo);
          }
          if (res.code == 200) {
            this.$message.success(`${this.dialogType}成功`);
            this.queryTable();
            this.addFormShow = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 设置新密码
    resetCode(row) {
      this.resetCodeShow = true;
      this.codeInfo.uid = row.uid;
    },
    editCode(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await studentApi.passwordOperation(this.codeInfo);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改密码成功!",
            });
          } else {
            this.$message.error(res.message);
          }
          this.resetCodeShow = false;
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 重置密码
    restartCode(row) {
      this.$confirm(
        `是否将用户【${row.realname}】的密码设置为初始密码【${row.default_password}】`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const _obj = {
            uid: row.uid,
            new_password: row.default_password,
            new_password_confirmation: row.default_password,
          };
          const res = await studentApi.passwordOperation(_obj);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "重置成功!",
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    // 添加、编辑标签
    async editLabel(row) {
      this.chioceUid = row.uid;
      const res = await studentApi.studentsTags({ uid: row.uid });
      if (res.code == 200) {
        this.editLabelShow = true;
        this.addLabel = res.data.data;
        this.userLabel = res.data.own;
      } else {
        this.$message.error(res.message);
      }
    },
    // 添加新标签
    async addNewLabelClick() {
      const res = await studentApi.tobTagsAdd({ name: this.addNewLabel });
      if (res.code == 200) {
        this.$message.success("新增标签成功");
        this.addNewLabel = "";
        const res1 = await studentApi.studentsTags({ uid: this.chioceUid });
        if (res1.code == 200) {
          this.editLabelShow = true;
          this.addLabel = res1.data.data;
          this.userLabel.forEach((item, index) => {
            this.addLabel.forEach((item1, index1) => {
              if (item.id == item1.id) {
                this.addLabel.splice(index1, 1);
              }
            });
          });
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 现有标签选择
    tagAddLabel(tag) {
      this.addLabel.forEach((item, index) => {
        //  'item',item);
        if (item.id == tag.id) {
          //  'item',item);
          this.addLabel.splice(index, 1);
        }
      });
      if (!this.userLabel.length) {
        this.userLabel.push(tag);
        this.userAddLabel.push(tag);
        return;
      }
      const _flag = this.userLabel.some((item, index) => {
        return item.id == tag.id;
      });
      if (!_flag) {
        //  1111);
        this.userLabel.push(tag);
        this.userAddLabel.push(tag);
      }
    },
    // 删除绑定标签
    deleteLabel(tag) {
      this.userLabel.forEach((item, index) => {
        if (item.id == tag.id) {
          this.userLabel.splice(index, 1);
        }
      });
      let flag = 0;
      this.userAddLabel.forEach((item, index) => {
        if (item.id == tag.id) {
          this.userAddLabel.splice(index, 1);
          flag = 1;
        }
      });
      let allFlag = 0;
      allFlag = this.addLabel.forEach((item, index) => {
        //  'item',item);
        return item.id == tag.id;
      });
      if (!allFlag) {
        this.addLabel.push(tag);
      }
      if (!flag) {
        const _flag = this.userLabel.some((item, index) => {
          return item.id == tag.id;
        });
        if (!_flag) {
          this.userDeleteLabel.push(tag);
        }
      }
    },
    // 用户新增标签
    submitLabel() {
      //  'userAddLabel',this.userAddLabel,'userDeleteLabel',this.userDeleteLabel);

      // let _addId = this.userAddLabel.map((item,index)=>{
      //   return item.id
      // })
      let _deleteId = this.userLabel.map((item, index) => {
        return item.id;
      });
      let _proArray = [];
      // if(_addId.length){
      _proArray.push(
        studentApi.studentsTagsAdd({
          uid: this.chioceUid,
          tag_id: _deleteId.join(",") 
        })
      );
      // }
      // _proArray.push(studentApi.studentsTagsDel({
      //   uid:this.chioceUid,
      //   tag_id:_deleteId.join(",")
      // }))
      Promise.all(_proArray).then((res) => {
        this.queryTable().then((res) => {
          this.$message.success("标签更新成功");
        });
        this.userAddLabel = [];
        this.userDeleteLabel = [];
        this.editLabelShow = false;
      });
    },

    // 开通会员
    buyGoodsBtn(row) {
      this.selectBuyGoodsShow = true;
      this.goodsNeedId = row.uid;
    },

    // 跳转已开课程
    skip(row) {
      this.$router.push({
        path: "/studentDetail",
        query: {
          name: row.username,
          realname: row.realname,
          uid: row.uid,
        },
      });
    },

    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },

    // 批量导入
    // 文件选择回调
    onChange(file, fileList) {
      //  fileList);
      this.fileData = file; // 保存当前选择文件
      this.fileName = file.name;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      let that = this;
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          console.log("data---", data);
          const workbook = that.XLSX.read(data, {
            type: "binary",
            // cellNF:true,
            raw: true,
          });
          console.log("workbook---", workbook);
          // if (workbook.SheetNames.length >= 1) {
          //   this.$message.success("表格导入成功")
          // }
          const wsname = workbook.SheetNames[0]; //取第一张表
          console.log("wsname---", wsname);
          const ws = that.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log("ws---", ws);
          that.outputs = []; //清空接收数据
          let _list = [];
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              realname: ws[i]["真实姓名（必填）【至少两个中文汉字】"],
              mobile: ws[i]["手机号（填写后可使用手机号登录）"],
              id_card: ws[i]["身份证号"],
              remark: ws[i]["备注"],
              username: ws[i]["用户名【老学员还需要填写用户名，即登录账号】"],
            };
            _list.unshift(sheetData);
          }
          if (_list.length) {
            // _list = JSON.stringify(_list)
            // studentApi.studentsImport({data:_list}).then(res=>{
            //   if(res.code == 200){
            //     this.$message.success("导入成功，请查看导入记录")
            //     this.queryTable()
            //   }else{
            //     this.$message.error(res.message)
            //   }
            // })
            this.excelList = _list;
            console.log("this.excelList", this.excelList);
          } else {
            this.$message.error("请先填入数据");
          }

          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    resetQuery() {
      this.timeFrame = [];
      this.costTimeArr = [];
      this.selectTags = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        mobile: "", //状态 -1全部 1启用 0禁用
        type: "-1", //是否激活 -1全部 1启用 0禁用
        call_id: "", //用户信息 支持账号真实姓名手机号
        realname: "",
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
        tag_id: "", //标签id
        pay_start_time: "", //
        pay_end_time: "",
        price_status:'0'
      };
      this.queryTable();
    },
    // 选择日期
    selectData(e) {
      //  e);
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
    },
    // 选择日期
    selectPayData(e) {
      //  e);
      if (e) {
        this.queryInfo.pay_start_time = e[0];
        this.queryInfo.pay_end_time = e[1];
      } else {
        this.queryInfo.pay_start_time = "";
        this.queryInfo.pay_end_time = "";
      }
    },
    exportExcel() {
      var titleList = [
        { title: "真实姓名（必填）【至少两个中文汉字】", key: "realname" },
        { title: "手机号（填写后可使用手机号登录）", key: "mobile" },
        { title: "身份证号", key: "id_card" },
        { title: "备注", key: "remark" },
        {
          title: "用户名【老学员还需要填写用户名，即登录账号】",
          key: "username",
        },
      ];
      var dataSource = [];
      var fileName = "学员信息导入模版";
      qee(titleList, dataSource, fileName);
    },
    skipImportRecord(row) {
      this.$router.push({
        path: "/importRecord",
        query: {
          type: 1,
        },
      });
    },
    skipImportRecordDetail(recordId) {
      this.$router.push({
        path: "/importRecordDetail",
        query: {
          recordId: recordId,
          type: 1,
        },
      });
    },
    openImport(row) {
      this.outerVisible = true;
    },
    importFile() {
      if (this.excelList.length) {
        this.excelList = JSON.stringify(this.excelList);
        studentApi.studentsImport({ data: this.excelList }).then((res) => {
          if (res.code == 200) {
            // this.$message.success("导入成功，请查看导入记录")
            this.fileName = "";
            this.excelList = [];
            this.queryTable();
            this.outerVisible = false;
            // this.$confirm('数据导入成功', '提示', {
            //     confirmButtonText: '查看导入数据'
            //   }).then(() => {
            //     this.skipImportRecord()
            //   })
            this.$alert("导入成功", "提示", {
              confirmButtonText: "查看导入数据",
              callback: (action) => {
                if (action == "confirm") {
                  this.skipImportRecordDetail(res.data.record_id);
                }
              },
            });
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("请先填入数据");
      }
    },
    excelImport() {
      this.fileName = "";
      this.excelList = [];
      this.outerVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    .el-button {
      margin: 0 20px 10px 0;
    }
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
</style>
